import { BaseDetails } from "../BaseDetails";
import { CampaignContent } from "./CampaignContent";
import { ChannelSettings } from "../ChannelSettings";
import { ManualReconfiguration } from "./ManualReconfiguration";
import { Targeting } from "../../Targeting";
import Divider from "components/Divider";

export const MetaTemplate = () => {
  return (
    <>
      <Divider margin="20px 0 16px 0" />

      <BaseDetails />

      <Divider margin="20px 0 16px 0" />

      <ManualReconfiguration />

      <Divider margin="20px 0 16px 0" />

      <Targeting />

      <Divider margin="20px 0 16px 0" />

      <ChannelSettings />

      <Divider margin="20px 0 16px 0" />

      <CampaignContent />
    </>
  );
};
